import $ from 'jquery';

class SearchForm {
  constructor() {
    this.navSearch = $('.js-nav-search .c-icon');
    this.navSearchForm = $('.js-nav-search-form');

    if (!this.navSearch.length || !this.navSearchForm.length) {
      return;
    }

    this.toggleForm();
  }

  toggleForm() {
    $(document).on('click', e => {
      if (
        !$(e.target).closest('.js-nav-search-form').length &&
        !$(e.target).hasClass('js-nav-search-form') &&
        !$(e.target).closest('.js-nav-search').length &&
        this.navSearch.parent().hasClass('is-open')
      ) {
        this.navSearch.parent().removeClass('is-open');
      }
    });

    this.navSearch.on('click', e => {
      const activeElement = $(e.currentTarget).parent();

      if (activeElement.hasClass('is-open')) {
        activeElement.removeClass('is-open');
      } else {
        activeElement.addClass('is-open');
      }
    });
  }
}

export default SearchForm;



// WEBPACK FOOTER //
// ./src/scripts/modules/search-form.js